import styled, { css } from 'styled-components';
import { getColorShade, getSizeBy } from '../../../src/styled/utils';
const verticalCSS = css `
  display: inline-block;
  height: 0.9em;
  vertical-align: middle;
`;
export const StyledDivider = styled.div `
  width: ${({ $type }) => $type === 'vertical' && '1px'};
  height: ${({ $type }) => $type === 'horizontal' && '1px'};
  margin-left: ${({ $variant, $type }) => $variant === 'inset' && $type !== 'vertical' && getSizeBy(10.5)};
  background: ${getColorShade('onSurface', 'border')};
  ${({ $type }) => $type === 'vertical' && verticalCSS};
`;
